<template>
  <div class="v4-main">
    <div class="v4-header " v-if="isLogin">
      <div class="v4-logo" @click="toPath('/')">
        <img src="../../assets/logo_icon_none.png" style="height:35px;margin-right: 10px;" >
        <img src="../../assets/logo_text_none.png" style="height:35px" >
      </div>
      <div class="v4-menu">
        <div class="v4-menu-item"
             :class="menuI===menuIndex?'active':''"
             @click="toPath(menuItem.url)"
             :key="'Menu'+menuIndex"
             v-if="menuItem.is_show===1&&menuItem.url!=='/'"
             v-for="(menuItem,menuIndex) in $store.state.menu">
          {{menuItem.name}}
        </div>
      </div>
      <div class="v4-user">
        <img :src="getUserAva">
        <span>{{$store.state.user_info.name}}</span>
        <div class="v4-user-op" style="z-index: 10000;">
          <div @click="toPath('/user/user_info')">个人中心</div>
          <div @click="toPath('/user/update_password')">修改密码</div>
<!--          <div @click="changeUpload">我在{{uploadType}}</div>-->
          <div @click="outLogin">退出登陆</div>
        </div>
      </div>
    </div>
    <div class="v4-content" >
      <div v-if="isLogin&&$store.state.menu[menuI]&&$store.state.menu[menuI].child.length!==0" class="v4-menu-base">
        <div v-if="menuBaseItem.is_show===1" v-for="menuBaseItem in $store.state.menu[menuI].child">
          <div class="v4-menu-base-item v4-menu-base-item-link"
               :class="menuBaseItem.id===menuBaseId?'active':''"
               @click="toPath(menuBaseItem.url)"
               v-if="menuBaseItem.child.filter(item=>{return item.is_show===1}).length===0">{{menuBaseItem.name}}</div>
          <div class="v4-menu-base-item v4-menu-base-item-info" v-else>{{menuBaseItem.name}}</div>
          <div class="v4-menu-base-item v4-menu-base-item-link"
               :class="menuBaseBItem.id===menuBaseId?'active':''"
               @click="toPath(menuBaseBItem.url)"
               v-if="menuBaseBItem.is_show===1"
               v-for="menuBaseBItem in menuBaseItem.child">
            {{menuBaseBItem.name}}
          </div>
        </div>
      </div>
      <router-view style="flex: 1;height: 100%;overflow: hidden;position: relative"/>
    </div>
  </div>
</template>

<script>
import {OutLogin} from "../../api/user";

export default {
  name: "BaseApp",
  props: ['isLogin'],
  data(){
    return {
      uploadType:'外面',
      menuI:0,
      menuBaseId:0,
    }
  },
  watch:{
    getPath:{
      handler:function (val, oldVal) {
        if (val!==oldVal) this.toPath(val,false)
      }
    }
  },
  computed:{
    getUserAva(){
      return this.$store.state.user_info.thumb&&this.$store.state.user_info.thumb.indexOf('http')!=-1?this.$store.state.user_info.thumb:(this.$store.state.source_host+this.$store.state.user_info.thumb)
    },
    getPath(){
      return this.$route.path
    }
  },
  mounted() {
    this.$store.commit('setSourceHost', "http://183.94.56.144:3030/uploads/")
  },
  methods:{
    changeUpload(){
      if (document.location.host=='192.168.11.199'){
        window.location = 'http://cc.gamebrain.io'
      }else{
        window.location = 'http://192.168.11.199'
      }
      // this.$router.go(0)
    },
    outLogin(){
      OutLogin({}).then(resp => {
        if (resp.code===200){
          this._set_login('','')
          this.$message.success(resp.message)
          window.location = '/'
        }
      })
    },
    toPath(url="",go=true){
      this.$store.state.menu.forEach((menu_item,menu_i) => {
        if (menu_item.url===url) this.menuI = menu_i
        menu_item.child.forEach((menu_base_item,menu_base_i)=>{
          if (menu_base_item.url===url){
            this.menuI = menu_i
            this.menuBaseId = menu_base_item.id
          }
          menu_base_item.child.forEach((menu_base_b_item,menu_base_b_i)=>{
            if (menu_base_b_item.url===url){
              this.menuI = menu_i
              this.menuBaseId = menu_base_b_item.id
              if (menu_base_b_item.is_show!==1) this.menuBaseId = menu_base_item.id
            }
          })
        })
      })
      if (go&&url) this.$router.push({ path: url }).catch(err => err)
    }
  }
}
</script>

<style scoped>
.v4-main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow: hidden;
}
.v4-header {
  user-select: none;
  z-index: 111;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  background: linear-gradient(
    to bottom,
    rgba(0,98,203,0.8),
    rgba(0,98,203,0.6),
    rgba(0,98,203,0.5),
    rgba(0,98,203,0.4))
}
.v4-logo {
  width: 150px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding:0 30px;
}
.v4-menu {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: bolder;
  color: rgba(255,255,255,1);
}
.v4-menu-item {
  height: 100%;
  display: flex;
  align-items: center;
  padding:0 20px;
}
.v4-menu-item:hover,.v4-menu-item.active{
  background: linear-gradient(
    to top,
    rgba(0,98,203,0.6),
    rgba(0,98,203,0.1));
  color: rgba(255,255,255,1);
}
.v4-user {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
  position: relative;
  color: rgba(255,255,255,1);
}
.v4-user > img {
  float: left;
  height: 40px;
  border-radius:50%;
  margin-right: 10px
}
.v4-user-op {
  width: 100px;
  top: 100%;
  right: -20px;
  z-index: 9999;
  position: absolute;
  display: none;
  text-align: center;
  background: rgba(0,98,203,0.2);
}
.v4-user-op > div{
  padding: 10px;
}
.v4-user-op > div:hover{
  background: rgba(0,98,203,0.4);
}
.v4-user:hover>.v4-user-op{
  display: block;
}
.v4-content{
  width: 100%;
  flex: 1;
  display: flex;
  overflow-y: hidden;
}
.v4-menu-base {
  height: 100%;
  padding:0 30px;
  /*background: rgba(0,98,203,0.2);*/
}
.v4-menu-base-item {
  margin: 20px 0;
  padding: 0 20px;
}
.v4-menu-base-item-info{
  font-size: 12px;
  color: rgba(0,98,203,0.4);
}
.v4-menu-base-item-link{
  font-size: 14px;
  cursor: pointer;
  color: rgba(0,98,203,0.8);
}
.v4-menu-base-item-link:hover,.v4-menu-base-item-link.active{
  background: linear-gradient(
    to top,
    rgba(0,98,203,0.4),
    rgba(0,98,203,0.3),
    rgba(0,98,203,0.2),
    rgba(0,98,203,0.1));
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/V4/BaseApp.vue